import { Video } from 'lucide-react';
import { useState, useRef } from 'react';

interface VideoRenderProps {
	videoUrl: string;
	videoImage: string;
	onStart?: (started: boolean) => void; // Nova prop para avisar o pai
}

const VideoRender = ({ videoUrl, videoImage, onStart }: VideoRenderProps) => {
	const [videoStarted, setVideoStarted] = useState(false);
	const iframeRef = useRef<HTMLIFrameElement>(null);

	const getYouTubeId = (url: string) => {
		if (url.includes('youtu.be/')) {
			return url.split('youtu.be/')[1].split(/[?&#]/)[0];
		}
		const regExp =
			/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
		const match = url.match(regExp);
		return match && match[2].length === 11 ? match[2] : null;
	};

	const videoId = getYouTubeId(videoUrl);

	const handlePlayClick = () => {
		if (videoId) {
			setVideoStarted(true);
			onStart?.(true); // Avisa o ProfessionalCard que o vídeo começou
		}
	};

	if (!videoId) {
		return (
			<div className="relative flex h-full w-full items-center justify-center bg-gray-200 text-xs">
				URL Inválida
			</div>
		);
	}

	return (
		<div className="relative h-full w-full" key={videoId}>
			{videoStarted && (
				<iframe
					ref={iframeRef}
					className="absolute inset-0 h-full w-full border-0"
					src={`https://www.youtube.com/embed/${videoId}?controls=1&modestbranding=1&autoplay=1&enablejsapi=1&rel=0&fs=1&playsinline=1`}
					title="YouTube video player"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
				/>
			)}

			{!videoStarted && (
				<div className="absolute inset-0 flex items-center justify-center bg-black/40">
					<div
						className="absolute inset-0 bg-cover bg-center"
						style={{ backgroundImage: `url('${videoImage}')` }}
					/>
					<div className="absolute inset-0 bg-black/20" />

					<button
						onClick={handlePlayClick}
						className="group relative z-10 flex h-12 w-12 items-center justify-center rounded-full border border-white/30 bg-white/20 backdrop-blur-sm transition-all hover:scale-110"
						aria-label="Play video"
					>
						<Video className="size-5 fill-white text-white" />
					</button>
				</div>
			)}
		</div>
	);
};

export { VideoRender };
